import BottomHorizontalMenuItem from './BottomHorizontalMenuItem'

export default BottomHorizontalMenuItem
